import { render, staticRenderFns } from "./WideNav.vue?vue&type=template&id=4d1c449a&scoped=true&"
import script from "./WideNav.vue?vue&type=script&lang=js&"
export * from "./WideNav.vue?vue&type=script&lang=js&"
import style0 from "./WideNav.vue?vue&type=style&index=0&id=4d1c449a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c449a",
  null
  
)

export default component.exports